module.exports = __webpack_public_path__ + "static/img/db-life.777c41c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/db-life.jpg
// module id = BmbV
// module chunks = 0